<ng-container *transloco="let t">
    <p>
        {{ t("auth.account-verification.securityCodeNotice") }}
    </p>

    <code-input
        [isCodeHidden]="false"
        (codeCompleted)="onCodeCompleted($event)"
    ></code-input>

    <button
        mat-raised-button
        color="accent"
        mat-dialog-close
        [disabled]="!complete"
    >
        {{ t("shared.submit") }}
    </button>
</ng-container>
